module.exports = __webpack_public_path__ + "static/media/leclerc4.de63a8e6.jpg";